import { useAppDispatch } from '@/Application/Hooks/Redux';
import { EDevice } from '@/constants';
import type { IOrderIntentResponse } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import { EPayStatus } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import {
  setCencoPayStatus,
  setIsModalCencopayGetTheAppVisible,
  setIsModalQRCencopayVisible,
  setQRData
} from '@/modules/perseo-billing/store/slices/billing';
import { redirectToUrl } from '@/modules/perseo-billing/utils/window';

import { handleBeforeUnload } from '../utils';

import { detectDevice } from './utils';

export const useCencopaySuccess = () => {
  const dispatch = useAppDispatch();

  const handleCencoPayMobileFlow = (data: IOrderIntentResponse) => {
    const redirectURI = data?.redirectURI;

    window.removeEventListener('beforeunload', handleBeforeUnload);

    redirectToUrl(redirectURI);
    setTimeout(() => {
      if (!document.hidden) {
        dispatch(setIsModalQRCencopayVisible(true));
        dispatch(setIsModalCencopayGetTheAppVisible(true));
        console.log('cencoPay app NOT detected - opening get the app modal');
      } else {
        console.log('cencoPay app detected');
        dispatch(setIsModalQRCencopayVisible(true));
      }
    }, 2500);

    window.addEventListener('beforeunload', handleBeforeUnload);
  };

  const handleCencoPayDesktopFlow = () => {
    dispatch(setIsModalQRCencopayVisible(true));
  };

  const handleCencoPaySuccess = (data: IOrderIntentResponse) => {
    const device = detectDevice();
    const isMobile = device === EDevice.ANDROID || device === EDevice.IOS;

    dispatch(setQRData(data));

    const cencopayStatus = EPayStatus.PENDING;
    dispatch(setCencoPayStatus(cencopayStatus));

    if (isMobile) {
      handleCencoPayMobileFlow(data);
    } else {
      handleCencoPayDesktopFlow();
    }
  };

  return { handleCencoPaySuccess };
};
